import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/react-hooks';
import { ThemeContext } from 'styled-components';

import Image from '../Image';
import ShareDropdown from '../ShareDropdown/ShareDropdown';

import { REMOVE_VISUALIZER } from '../../Queries';
import { getVendorCustomAttribute } from '../../Utils/CartUtils';
import { getSelectedProductsFromQueryParams, getThumbnailUrl } from '../../Utils/VisualizerUtils';

import { StyledPinkButton, StyledCopyWrapper, StyledTitle, StyledImageWrapper } from './AccountVisualizerStyles';

var AccountVisualizerCard = function AccountVisualizerCard(_ref) {
  var addVariantToCart = _ref.addVariantToCart,
      vis = _ref.vis,
      setVisData = _ref.setVisData,
      visData = _ref.visData;

  var _useContext = useContext(ThemeContext),
      dormifyPink = _useContext.dormifyPink;

  var _useMutation = useMutation(REMOVE_VISUALIZER),
      _useMutation2 = _slicedToArray(_useMutation, 1),
      removeVisualizerMutation = _useMutation2[0];

  var queryParams = vis.visualizerLink.split('?')[1];

  var _getSelectedProductsF = getSelectedProductsFromQueryParams(queryParams, visData.products),
      selectedProducts = _getSelectedProductsF.selectedProducts;

  var handleAddToCart = function handleAddToCart() {
    var availableProducts = selectedProducts.filter(function (prod) {
      return prod.availableForSale;
    });
    var addToCartItems = availableProducts.map(function (product) {
      var customAttributes = getVendorCustomAttribute(product.vendor);
      customAttributes.push({ key: '_cc', value: 'Built by me' });
      return {
        variantId: product.variantId,
        quantity: 1,
        customAttributes: customAttributes
      };
    });
    addVariantToCart(addToCartItems);
  };

  var handleRemoveClick = function handleRemoveClick() {
    removeVisualizerMutation({
      variables: {
        userId: window.Dormify.customerId,
        url: vis.visualizerLink,
        title: vis.visualizerTitle
      }
    }).then(function (_ref2) {
      var data = _ref2.data;

      // update user data (removeVisualizer returns user object with the above visualizer removed)
      setVisData(Object.assign({}, visData, { user: data.removeVisualizer }));
    });
  };
  return React.createElement(
    'li',
    null,
    React.createElement(
      StyledImageWrapper,
      { href: vis.visualizerLink },
      React.createElement(Image, {
        src: getThumbnailUrl({ relativeUrl: vis.visualizerLink }),
        alt: vis.visualizerTitle
      })
    ),
    React.createElement(
      StyledTitle,
      null,
      vis.visualizerTitle
    ),
    React.createElement(
      StyledCopyWrapper,
      null,
      React.createElement(
        StyledPinkButton,
        { onClick: handleAddToCart },
        'Add to Cart'
      ),
      React.createElement(
        'a',
        { href: vis.visualizerLink },
        'Edit'
      ),
      React.createElement(ShareDropdown, {
        relativeUrl: vis.visualizerLink,
        buttonColor: dormifyPink,
        withIcon: false,
        selectedProducts: selectedProducts
      }),
      React.createElement(
        'button',
        { onClick: handleRemoveClick },
        'Remove'
      )
    )
  );
};

AccountVisualizerCard.propTypes = {
  addVariantToCart: PropTypes.func.isRequired,
  vis: PropTypes.object,
  setVisData: PropTypes.func,
  visData: PropTypes.object
};

export default AccountVisualizerCard;